module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Good Time Coming")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/styles.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("There’s a good time coming, boys.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("A good time coming:")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("War in all men’s eyes shall be")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("A monster of iniquity")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("In the good time coming.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Nations shall not quarrel then,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("To prove which is the stronger;")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Nor slaughter men for glory’s sake;–")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-space-after"
  }, [_vm._v("Wait a little longer.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source"
  }, [_vm._v("The Good Time Coming, 1846,")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source"
  }, [_vm._v("words by Charles Mackay; melody by Stephen Foster.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0